import React, {Component} from 'react';
import './index.scss';

import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../store';
import { Cart, ProductType } from '../../store/ducks/cart/types';
import * as CartActions from '../../store/ducks/cart/actions';
import { Param } from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import { Diversos } from '../../services/diversos';
import './index.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'


  interface StateProps { 
    cart?: Cart;
    param: Param;
  } 

  interface DispatchProps {
    add(cart: ProductType): void;
    update(cart: ProductType): void;
    drop(rowid: string): void;
    setParam(data: Param): void;
  }


  interface OwnProps {
    imageOver: any,
    imageNormal: any,
    item?: any;
  }

  type Props = StateProps & DispatchProps & OwnProps;

  class Product extends Component<Props> {

    state:any

    constructor(props) {
      super(props);
      this.state = {
        imgSrc: this.props.imageNormal
      }

      console.log(this.props.imageNormal);
    }

    componentDidMount() {
    }
  
    handleMouseOver() {
      this.setState({
        imgSrc: this.props.imageOver
      });
    }
    
    handleMouseOut() {
      this.setState({
        imgSrc: this.props.imageNormal
      });
    }

    private async handleAddCart (event) {
      const self = this;
      event.preventDefault();
      self.props.add({
        codigo: self.props.item.CODIGO,
        nome: self.props.item.NOME,
        price: self.props.item.PRECO,
        qty: 1
      });
      self.props.setParam({ ...self.props.param, cartOpened: true });
    }

    render () {

      return (
        <>
          
        <a href={`/${Diversos.toSeoUrl(this.props.item.NOME)}`}
        target="_self"
        onMouseOver={this.handleMouseOver.bind(this)}
        onMouseOut={this.handleMouseOut.bind(this)}
        className="my-5 product-container"
        title="Ver detalhes do produto">

          {/* Se o produto tiver promoção, ativar badge
          <span className="sale-badge">
            <h6> 50% OFF </h6>
          </span> */}
          
          <Row className="w-100 img-wrapper">
            <Image src={this.state.imgSrc} className="product-img" alt=""/>
          </Row>
          <Row className="w-100 product-info">
            <Row className="product-name">
              {this.props.item.NOME}
            </Row>
            <Row className="price-and-cart">
              <Col xs={8} className="rmv-padding">
                <p className="product-price"> R$ {Diversos.number_format(this.props.item.PRECO,2,",","")} </p>
              </Col>
              <Col xs={4} className="d-flex flex-end rmv-padding">
                <FontAwesomeIcon icon={faCartPlus} onClick={this.handleAddCart.bind(this)} className="add-to-cart" title="Adicionar ao carrinho"/>
              </Col>
            </Row>
          </Row>
          {/* <div onMouseOver={this.handleMouseOver.bind(this)}
          onMouseOut={this.handleMouseOut.bind(this)} className="product-container">
            <span className="img-wrapper">
              <img src={this.state.imgSrc} className="product-img" alt=""></img>    
            </span>
            <div className="product-info">
              <p className="product-name"> {this.props.item.NOME} </p>
              <div className="price-and-cart">
                <p className="product-price"> R$ {Diversos.number_format(this.props.item.PRECO,2,",","")} </p>
                <FontAwesomeIcon icon={faCartPlus} onClick={this.handleAddCart.bind(this)} className="add-to-cart" title="Adicionar ao carrinho"/>
              </div>
            </div>
          </div> */}
        </a>

        </>
      );
    }
  }

const mapStateToProps = (state: ApplicationState) => ({
  cart: state.cart.data,
  param: state.param.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...CartActions, ...ParamActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Product);